import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PT from 'prop-types';
import { r as renderIconSVG } from './utils/renderIconSVG-a13f426b.js';
import { R as RemoteIcon } from './RemoteIcon/RemoteIcon-c5b515e7.js';
import { i as isHorizontalFlipOnRTL } from './utils/isHorizontalFlipOnRTL-e979c034.js';
import { g as getIconSize } from './utils/getIconSize-cfb94588.js';
import { I as IconClassWrapper, a as IconWrapperStyled } from './Icon.styles-05ad9386.js';

const Icon = ({
  type,
  size,
  transform,
  blockSize = false,
  'data-testid': dataTestId,
  ...rest
}) => {
  if (typeof type === 'string') {
    return /*#__PURE__*/React__default.createElement(RemoteIcon, _extends({}, rest, {
      key: type,
      type: type,
      size: size,
      transform: transform,
      blockSize: blockSize,
      "data-testid": dataTestId
    }));
  }
  const [iconName, horizontalFlipOnRTL] = isHorizontalFlipOnRTL(type.iconName);
  const icon = {
    ...type,
    iconName
  };
  const iconFontSize = getIconSize(size);
  return /*#__PURE__*/React__default.createElement(IconClassWrapper, {
    $pulse: iconName === 'spinner',
    $size: size,
    $fontSize: iconFontSize
  }, className => /*#__PURE__*/React__default.createElement(IconWrapperStyled, _extends({}, rest, {
    $blockSize: blockSize,
    $horizontalFlipOnRTL: horizontalFlipOnRTL,
    dangerouslySetInnerHTML: {
      __html: renderIconSVG(icon, transform, className)
    }
    // Used to help identify which icon is being used for testing purposes
    ,
    "data-testid": dataTestId || `storm-ui-icon-${iconName}`
  })));
};
Icon.propTypes = {
  /**
   * The type of Icon.
   */
  type: PT.oneOfType([PT.string, PT.shape({
    iconName: PT.string,
    prefix: PT.oneOf(['fas', 'fab', 'far', 'fal', 'fad']),
    icon: PT.arrayOf(PT.oneOfType([PT.number, PT.string, PT.arrayOf(PT.string)]))
  })]).isRequired,
  /**
   * Font Awesome [sizing classes ](https://fontawesome.com/v5.0.13/how-to-use/on-the-web/styling/sizing-icons).
   */
  size: PT.oneOf(['xs', 'sm', 'lg', '2x', '3x', '5x', '7x', '10x']),
  /**
   * Font Awesome [transform element attribute ](https://fontawesome.com/v5.0.13/how-to-use/on-the-web/styling/power-transforms).
   */
  transform: PT.string,
  /**
   * Changes the `<svg/>` to be `display: block;`.
   * Use when centering icons in small spaces.
   */
  blockSize: PT.bool
};
Icon.defaultProps = {
  size: undefined,
  transform: undefined,
  blockSize: false,
  'data-testid': undefined
};
var Icon$1 = Icon;

export { Icon$1 as I };
//# sourceMappingURL=Icon-0938d6c4.js.map
